import { useContext } from 'react';
import { PenaltyContext } from '@/contexts/penalty/PenaltyContext';

export function usePenalty() {
  const context = useContext(PenaltyContext);
  if (!context) {
    throw new Error('usePenalty must be used within a PenaltyProvider');
  }
  return context;
}
